<app-dialog-sidebar>
    <header class="header">
        <h1 class="no-margin-bottom display-3">{{ 'giftOptions.labels.headline' | translateSafe }}</h1>
    </header>
    <div class="basket-gift-options" (appNgAfterViewInit)="onComponentViewInit()">
        <div class="content-wrapping">
            <app-basket-gift-wrapping-options
                id="wrappingEl"
                *ngIf="data.giftWrappingOptions.length && data.giftWrappingOptionsAllowed"
                [options]="data.giftWrappingOptions"
                [selectedId]="data.selectedWrappingId"
                (giftWrappingChange)="onGiftWrappingChange($event)"
            ></app-basket-gift-wrapping-options>
        </div>

        <div class="content-wrapping">
            <app-basket-gift-card-options
                id="cardEl"
                *ngIf="data.giftCardOptions.length"
                [options]="data.giftCardOptions"
                [selectedCardId]="data.selectedCardId"
                (giftCardChange)="onCardChange($event)"
            ></app-basket-gift-card-options>
        </div>

        <div class="content-wrapping">
            <app-basket-gift-card-message-form
                id="messageEl"
                *ngIf="data.giftCardOptions.length"
                [data]="data.cardText"
                [allowMessage]="allowMessage"
                (messageChange)="onCardBodyChange($event)"
            ></app-basket-gift-card-message-form>
        </div>

        <div class="content-wrapping no-margin actions">
            <app-icon-button type="button" variant="primary" (click)="finishCustomization()">{{
                (data.confirmButtonText ? data.confirmButtonText : 'giftOptions.labels.save') | translate
            }}</app-icon-button>
        </div>
    </div>
</app-dialog-sidebar>
